module.exports = __webpack_public_path__ + "static/img/phone_carlogo.5d94e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone_carlogo.png
// module id = xE/T
// module chunks = 0